import React, { useState } from 'react';
import TypeWriter from '../components/TypeWriter';
import './Encrypt.css';

const Encrypt = () => {
  const [message, setMessage] = useState('');
  const [encrypted, setEncrypted] = useState('');
  const [copySuccess, setCopySuccess] = useState(false);
  const [status, setStatus] = useState('');

  const handleEncrypt = async () => {
    if (!message.trim()) {
      setStatus('Please enter a message to encrypt.');
      return;
    }

    try {
      setStatus('Encrypting...');
      const response = await fetch('https://bharathchilaka-test.hf.space/api/encrypt', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message: message.trim()
        })
      });

      const data = await response.json();
      
      if (response.ok) {
        setEncrypted(data.encrypted_message);
        setStatus('Message encrypted successfully!');
      } else {
        setStatus(data.detail || 'Failed to encrypt message');
      }
    } catch (error) {
      console.error('Encryption error:', error);
      setStatus('Failed to encrypt message. Please ensure the backend is running.');
    }
  };

  const handleClear = () => {
    setMessage('');
    setEncrypted('');
    setStatus('');
    setCopySuccess(false);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(encrypted).then(() => {
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    });
  };

  return (
    <div className="encrypt-page">
      <div className="container">
        {/* Header */}
        <div className="encrypt-header">
          <h1>
            <TypeWriter 
              text="Encrypt Your Message" 
              speed={90} 
              cursorColor="white"
            />
          </h1>
          <p>Secure your communication with GestureSpeak's built-in encryption tool.</p>
        </div>

        {/* Message Input */}
        <div className="message-section">
          <h2 className="encrypt-section-heading">Enter Your Message</h2>
          <textarea
            className="message-input"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your message here..."
          />
          <div className="message-actions">
            <button className="btn btn-primary" onClick={handleEncrypt}>
              Encrypt
            </button>
            <button className="btn btn-secondary" onClick={handleClear}>
              Clear
            </button>
          </div>
          {status && (
            <div className={`status-message fade-in ${status.includes('Failed') || status.includes('Error') || status.includes('Please') ? 'error' : ''}`}>
              {status}
            </div>
          )}
        </div>

        {/* Encrypted Output */}
        {encrypted && (
          <div className="result-section">
            <h2>Encrypted Output</h2>
            <div className="encrypted-container">
              <textarea
                className="encrypted-output"
                value={encrypted}
                readOnly
              />
              <button
                className={`btn copy-btn ${copySuccess ? 'copy-success' : ''}`}
                onClick={handleCopy}
              >
                {copySuccess ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>
        )}

        {/* Instructions */}
        <div className="instructions-section">
          <h2>How It Works</h2>
          <div className="instructions-grid">
            <div className="instruction-item">
              <div className="instruction-icon">📝</div>
              <h4>Write Your Message</h4>
              <p>Type any message you want to secure using our encryption tool.</p>
            </div>
            <div className="instruction-item">
              <div className="instruction-icon">🔐</div>
              <h4>Encrypt Instantly</h4>
              <p>Click the Encrypt button to convert your message into a secure format.</p>
            </div>
            <div className="instruction-item">
              <div className="instruction-icon">📋</div>
              <h4>Copy & Share</h4>
              <p>Use the Copy button to share your encrypted message safely.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Encrypt;
